import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, Alert, Form, Modal, Label, Input, Button, Table, UncontrolledTooltip } from "reactstrap";
import axios from 'axios';
import * as ur from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import TreeMenu from 'react-simple-tree-menu';
import '../../../node_modules/react-simple-tree-menu/dist/main.css';
import PropTypes from 'prop-types';
const Organogram = () => {
      
      toastr.options = TOAST_OPTIONS;
      const [modal_role, setmodal_role] = useState(false);
      
      const [rolesList, setRolesList] = useState([]);
      const [parentRoleId, setParentRoleId] = useState('')
      const [roleId, setRoleId] = useState('')
      const [roleName, setRoleName] = useState('')
      const [isLoading, setIsLoading] = useState(false)
      const [isEdit, setIsEdit] = useState(false);
      const [treeData, setTreeData] = useState([])
      const [userId, setUserId] = useState('')
      
      const getData = () => {
        axios.get(ur.TITLES, Config).then((r)=>{ setRolesList(r.data);  }).catch((e)=>{  console.log(e); });
        axios.get(ur.HRORGANOGRAM, Config).then((r)=>{ setTreeData(r.data);  }).catch((e)=>{  console.log(e); });
        
      }
      useEffect(() => {
       getData();
      },[]);
    
      const handleEditItem = (label, url) => {
        setIsLoading(true)
        if(url.includes('role')){
          tog_role();
          let id = url.split("/")[1]
          axios.get(`${ur.TITLES}/?${id}`, Config)
          .then((r)=>{  
            setRoleName(r.data[0].title)
            setRoleId(r.data[0].id) 
            setParentRoleId(r.data[0].reportsTo)
            setIsEdit(true);
          }).catch((e)=>{ 
            console.log(e); 
          }).finally(()=>{
            setIsLoading(false)
          })
        }
      }


      const removeBodyCss = () => {
        document.body.classList.add("no_padding");
      }
      const tog_role = () => {
        setmodal_role(!modal_role);
        removeBodyCss();
      }

    const handleSaveRole = () =>{
      if(roleName == ""){
        toastr.error('Enter role name')
      }else{
        let data = {}
        
        setIsLoading(true)
        axios.post(ur.CLUSTERS, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == 1){
            toastr.success(r.data.message)
            tog_role()
          }else{
            toastr.error(r.data.message)
          }
          getData()
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
        }).finally(()=>{
            setIsLoading(false)
        })  
     }  
    }   





      const handleDeleteCluster = () =>{
        const data = { name : "cluster", id: clusterId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_cluster();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }

      const handleAddTitle = () =>{
        const data = {
            id        : isEdit?roleId:'',
            title     : roleName,
            reportsTo : parentRoleId,
            action    : isEdit?'edit':'add'
        }
        setIsLoading(true)
        axios.post(ur.TITLES, JSON.stringify(data), Config).then((r)=>{
            toastr.info(r.data.message)
            setIsLoading(false)
            setIsEdit(false)
            setRoleName('')
            setParentRoleId('')
            setRoleId('')
            tog_role()
            getData()
        }).catch((e)=>{
            console.log(e)
        }).finally(()=>{
            setIsLoading(false)
        })
      }
      const handleDeleteTitle = () =>{
        const data = {
          id        : roleId,
          title     : 'xx',
          reportsTo : 'xx',
          action    : 'delete'
      }
      setIsLoading(true)
      axios.post(ur.TITLES, JSON.stringify(data), Config).then((r)=>{
        if(r.data.status == '1'){
          toastr.info(r.data.message)
          setIsEdit(false)
          setRoleName('')
          setParentRoleId('')
          setRoleId('')
          tog_role()
          getData()
        }else{
          toastr.error(r.data.message)
        } 
      }).catch((e)=>{
          console.log(e)
      }).finally(()=>{
          setIsLoading(false)
      })
      }


        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Organogram | {ur.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
      
                                <Modal isOpen={modal_role} toggle={() => { tog_role() }} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Edit`:`Add`} Employee Role</h5>
                                    <button onClick={() => { setmodal_role(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <select className="form-select"  value={parentRoleId} onChange={(e)=>setParentRoleId(e.target.value)}>
                                            <option value="">None</option>
                                            {rolesList.map((r,k)=>(<option key={k} value={r.id}>{r.title}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Job Title</label>
                                            <Input type="text" className="form-control"  value={roleName} onChange={(e)=>setRoleName(e.target.value)} />
                                        </div>
                                    </Col>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && (<><button onClick={()=>{ setIsEdit(false); setParentRoleId(roleId); setRoleName(''); }} className="btn btn-primary" data-dismiss="modal">Add Subordinate Title</button><button  className="btn btn-danger" onClick={handleDeleteTitle} data-dismiss="modal">Delete Title</button></>)}
                                    <button className="btn btn-success" onClick={handleAddTitle}>Save Job Title...</button>
                                    </>)}
                                  </div>
                                </Modal>  
                        <Row>

                        <Col lg={12}>
                          <Card>
                          
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">ORGANOGRAM</h5>
                          
                            <CardBody>                            
                              <TreeMenu data={treeData} initialOpenNodes={['first-level-node-1', 'second-level-node-8', 'third-level-node-9']}   onClickItem={({ key, label, ...props }) => {  handleEditItem(label, props.url)   }} />  
                            </CardBody>
                          </Card>
                        </Col>
                        
                      </Row> 
                        
                           

                    </Container>
                </div>
            </>
        );
    }
    Organogram.propTypes = {
      url: PropTypes.any
    };
export default Organogram;